export default __webpack_public_path__ + "static/20210505_KMW_by_Kruszewski_607-c9595b072037956de0424f5adce531a9.jpg";